/* Isolated Inira product page: gallery, content drawers and Shopify cart. */
(() => {
  if (!document.body.classList.contains('arrae-test') && !document.querySelector('[data-inira-reference-components]')) return;
  if (window.iniraReferenceComponentsReady) return;
  window.iniraReferenceComponentsReady = true;
  const ingredientMobile = matchMedia('(max-width: 749px)');
  const updateIngredientOrientation = () => {
    document.querySelectorAll('.at-ingredients [role="tablist"]').forEach(list => list.setAttribute('aria-orientation', ingredientMobile.matches ? 'horizontal' : 'vertical'));
  };
  updateIngredientOrientation();
  ingredientMobile.addEventListener('change', updateIngredientOrientation);
  const syncIngredient = (section, index) => {
    section.querySelectorAll('[data-at-tab]').forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      const description = section.querySelector(`[data-at-description="${i}"]`);
      if (description) description.hidden = !active;
      if (active && ingredientMobile.matches) {
        const list = tab.closest('[role=tablist]');
        const offset = tab.getBoundingClientRect().left - list.getBoundingClientRect().left;
        list.scrollTo({left:list.scrollLeft + offset - (list.clientWidth - tab.offsetWidth) / 2, behavior:motion()});
      }
    });
  };
  const showIngredient = (section, requestedIndex) => {
    const slides = [...section.querySelectorAll('.at-ingredient-panels > [role=tabpanel]')];
    const index = Math.max(0, Math.min(slides.length - 1, requestedIndex));
    section.dataset.ingredientIndex = index;
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
      slide.setAttribute('aria-hidden', String(i !== index));
      slide.inert = i !== index;
    });
    const previous = section.querySelector('[data-at-ingredient-prev]');
    const next = section.querySelector('[data-at-ingredient-next]');
    if (previous) previous.hidden = index === 0;
    if (next) next.hidden = index === slides.length - 1;
    syncIngredient(section, index);
    if (document.activeElement === previous && previous.hidden) next?.focus({preventScroll:true});
    if (document.activeElement === next && next.hidden) previous?.focus({preventScroll:true});
  };
  let returnFocus;
  const dialog = () => document.querySelector('[data-at-dialog]');
  const open = content => {
    const modal = dialog();
    if (!modal) return;
    returnFocus = document.activeElement;
    modal.classList.remove('at-drawer');
    modal.querySelector('[data-at-dialog-body]').replaceChildren(content);
    if (!modal.open) modal.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const close = () => {
    const modal = dialog();
    modal?.querySelectorAll('video').forEach(video => video.pause());
    modal?.close();
    document.documentElement.style.overflow = '';
    returnFocus?.focus();
  };
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  const root = () => window.Shopify?.routes?.root || '/';
  const updatePrice = () => {
    const selected = document.querySelector('[data-at-pack]:checked');
    if (selected) {
      document.querySelectorAll('[data-at-sticky-price]').forEach(price => price.textContent = selected.dataset.price);
      document.querySelectorAll('[data-at-compare-price]').forEach(price => {price.textContent = selected.dataset.compare || ''; price.hidden = !selected.dataset.compare;});
    }
  };
  const addToCart = async form => {
    const button = form.querySelector('[type="submit"]');
    if (button.disabled || form.dataset.busy === 'true') return;
    const selected = form.querySelector('[data-at-pack]:checked');
    const variantId = Number(form.querySelector('[name="id"]').value);
    const quantity = Number(selected?.value);
    const status = form.querySelector('[data-at-cart-status]');
    if (!variantId || ![1, 2, 3].includes(quantity)) {
      status.textContent = 'Selecciona una opción disponible.';
      return;
    }
    const label = form.querySelector('[data-at-buy-label]');
    const originalLabel = label.textContent;
    form.dataset.busy = 'true'; button.disabled = true; label.textContent = 'AÑADIENDO…';
    form.querySelector('fieldset').disabled = true;
    status.textContent = '';
    try {
      const properties = {};
      const giftId = Number(form.dataset.atGiftId);
      const giftEligible = selected.dataset.gift === 'true' && quantity >= 2 && giftId > 0;
      if (giftEligible) properties._inira_volume_gift = 'pastillero';
      const items = [{id:variantId,quantity,properties}];
      if (giftEligible) {
        const cartResponse = await fetch(`${root()}cart.js`, {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error('No se ha podido comprobar tu carrito. Inténtalo de nuevo.');
        const cart = await cartResponse.json();
        if (!cart.items.some(item => Number(item.variant_id) === giftId)) {
          items.push({id:giftId,quantity:1,properties:{_inira_gift:'cart-threshold-pastillero'}});
        }
      }
      const response = await fetch(`${root()}cart/add.js`, {
        method:'POST', headers:{Accept:'application/json','Content-Type':'application/json'}, body:JSON.stringify({items})
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'No se ha podido añadir el producto. Inténtalo de nuevo.');
      status.textContent = 'Producto añadido. Abriendo tu carrito…';
      window.location.assign(`${root()}cart`);
    } catch (error) {
      status.textContent = error.message || 'No se ha podido añadir el producto. Inténtalo de nuevo.';
    } finally {
      form.dataset.busy = 'false'; button.disabled = false; label.textContent = originalLabel;
      form.querySelector('fieldset').disabled = false;
    }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-at-close]')) close();
    if (target.matches('[data-at-carousel]')) {
      const track=document.querySelector(`[data-at-track="${target.dataset.atCarousel}"]`);
      if(track){const end=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;track.scrollTo({left:end?0:track.scrollLeft+track.clientWidth,behavior:motion()});}
    }
    if (target.matches('[data-at-formula]')) {
      const formula = target.closest('.at-ingredients')?.querySelector('[data-at-formula-content]') || document.getElementById('at-formula');
      if (formula) open(formula.content.cloneNode(true));
    }
    if (target.matches('[data-at-tab]')) {
      const section = target.closest('.at-ingredients');
      showIngredient(section, Number(target.dataset.atTab));
    } else if (target.matches('[data-at-routine],[data-at-product-tab]')) {
      target.closest('[role=tablist]').querySelectorAll('[role=tab]').forEach(tab => {
        const active = tab === target;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !active;
      });
      if (target.matches('[data-at-product-tab]')) {
        const section = document.getElementById(target.getAttribute('aria-controls')).querySelector('.at-ingredients');
        if (section) showIngredient(section, Number(section.dataset.ingredientIndex || 0));
      }
    }
    if (target.matches('[data-at-ingredient-prev],[data-at-ingredient-next]')) {
      const section = target.closest('.at-ingredients');
      showIngredient(section, Number(section.dataset.ingredientIndex || 0) + (target.hasAttribute('data-at-ingredient-next') ? 1 : -1));
    }
    if (target.matches('[data-at-image]')) {
      const image = target.querySelector('img').cloneNode(); image.removeAttribute('loading'); open(image);
    }
    if (target.matches('[data-at-ingredient]')) {
      const content = document.getElementById(`at-ingredient-${target.dataset.atIngredient}`);
      if (content) {open(content.content.cloneNode(true));dialog().classList.add('at-drawer');}
    }
    if (target.matches('[data-at-video]')) {
      const video = document.createElement('video');
      video.src = target.dataset.atVideo; video.controls = true; video.playsInline = true;
      open(video); video.play().catch(() => {});
    }
    if (target.matches('[data-at-search]')) {
      const content = document.createElement('div');
      content.innerHTML = '<h2>Buscar en Inira</h2><form method="get"><input type="search" name="q" aria-label="Buscar productos" placeholder="Buscar un producto…" required><button aria-label="Buscar">→</button></form>';
      content.querySelector('form').action = `${root()}search`;open(content);
    }
    if (target.matches('[data-at-menu]')) {
      const menu = document.querySelector('.at-mobile-menu'); menu.hidden = !menu.hidden;
      target.setAttribute('aria-expanded', String(!menu.hidden));
    }
    if (target.closest('.at-mobile-menu') && target.tagName === 'A') {
      document.querySelector('.at-mobile-menu').hidden = true;
      document.querySelector('[data-at-menu]').setAttribute('aria-expanded', 'false');
    }
    if (target.matches('[data-at-thumb]')) {
      const gallery = document.querySelector('.at-gallery-grid');
      gallery.scrollTo({left:gallery.clientWidth*Number(target.dataset.atThumb),behavior:motion()});
    }
    if (target.matches('[data-at-prev],[data-at-next]')) {
      const gallery = document.querySelector('.at-gallery-grid');
      gallery.scrollBy({left:(gallery.firstElementChild.getBoundingClientRect().width+16)*(target.hasAttribute('data-at-next')?1:-1),behavior:motion()});
    }
    if (target.matches('[data-at-scroll-packs]')) document.getElementById('at-packs')?.scrollIntoView({behavior:motion(),block:'center'});
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-at-tab],[data-at-routine],[data-at-product-tab]');
    if (!tab || !['ArrowDown','ArrowUp','ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('[role=tablist]').querySelectorAll('[role=tab]')];
    const direction = ['ArrowDown','ArrowRight'].includes(event.key) ? 1 : -1;
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + direction + tabs.length) % tabs.length;
    tabs[index].click(); tabs[index].focus();
  });
  document.addEventListener('change', event => {if(event.target.matches('[data-at-pack]')) updatePrice();});
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-at-product-form]')) return;
    event.preventDefault(); addToCart(event.target);
  });
  const init = () => {
    updateIngredientOrientation();
    const modal = dialog();
    if (modal && !modal.dataset.bound) {
      modal.dataset.bound = 'true';
      modal.addEventListener('cancel', event => {event.preventDefault();close();});
      modal.addEventListener('click', event => {
        if(event.target===modal){const rect=modal.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close();}
      });
    }
    document.querySelectorAll('.at-ingredients').forEach(section => {
      if (section.dataset.fadeBound) return;
      section.dataset.fadeBound = 'true';
      showIngredient(section, 0);
    });
    const gallery = document.querySelector('.at-gallery-grid');
    if (gallery && !gallery.dataset.bound) {
      gallery.dataset.bound = 'true';
      gallery.addEventListener('scroll',()=>{
        const index=Math.round(gallery.scrollLeft/(gallery.firstElementChild.getBoundingClientRect().width+16));
        document.querySelector('[data-at-gallery-count]').textContent=`${index+1} / ${gallery.children.length}`;
        document.querySelectorAll('[data-at-thumb]').forEach((thumb,i)=>{if(i===index)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});
      },{passive:true});
    }
    updatePrice();
  };
  let scheduled = false;
  const sticky = () => {
    const buy=document.querySelector('.at-buy'),bar=document.querySelector('.at-sticky-buy');
    if(buy&&bar){const rect=buy.getBoundingClientRect();bar.hidden=rect.bottom>0;}
    scheduled=false;
  };
  window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sticky);}},{passive:true});
  window.addEventListener('resize',sticky);
  document.addEventListener('shopify:section:load',()=>{init();sticky();});
  init();sticky();
})();
